<script>
  import {
    Tabs,
    TabsItem,
    Breadcrumb,
    BreadcrumbItem,
    Loader,
  } from "@gl/design-system";
  import { GroupsRepository } from "../../repositories/index";
  import { Route, Router } from "svelte-routing";
  import { navigate } from "../../utils/index";
  import { Layout } from "../../components/index";
  import { onMount, getContext } from "svelte";
  import { _, contract } from "../../stores/index";
  import GroupMembers from "./GroupMembers.svelte";
  import GroupRoles from "./GroupRoles.svelte";
  const { isAuthorized } = getContext("isAuthorized");

  export let id;

  let group = {};
  let loading = true;

  const basepath = "groups";
  let selectedTab = "members";

  const setSelectedTabFromPathname = () => {
    const path = decodeURIComponent(window.location.pathname);

    if (path.includes("roles")) {
      selectedTab = "roles";
    } else {
      selectedTab = "members";
    }
  };

  async function fetchGroup() {
    try {
      loading = true;

      group = await GroupsRepository.getGroup(id, { missingPolicies: true });
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    fetchGroup();
    setSelectedTabFromPathname();
  });
</script>

{#if !loading}
  <Layout selected="groups" fillHeight>
    <Breadcrumb>
      <BreadcrumbItem
        on:click={() => navigate("/groups")}
        on:keypress={(e) => {
          if (e.key === "Enter") navigate("/groups");
        }}
        >{$_("common.groups")}
      </BreadcrumbItem>
      <BreadcrumbItem current>
        {group.data.name}
      </BreadcrumbItem>
    </Breadcrumb>

    <h3 class="gl-title level-3">
      {$_("common.group")}: {group.data.name}
    </h3>

    <Tabs class="mt-5">
      <TabsItem
        selected={selectedTab === "members"}
        on:click={() => {
          selectedTab = "members";
          navigate(`/${basepath}/${id}/members`);
        }}
      >
        {$_("layout.group.members")}
      </TabsItem>

      {#if $isAuthorized("policy_read")}
        <TabsItem
          selected={selectedTab === "roles"}
          on:click={() => {
            selectedTab = "roles";
            navigate(`/${basepath}/${id}/roles`);
          }}
        >
          {$_("layout.group.roles")}
        </TabsItem>
      {/if}
    </Tabs>

    <Router {basepath}>
      <Route path="/members">
        <GroupMembers {id} {group} />
      </Route>
      <Route path="/roles">
        <GroupRoles {id} {group} />
      </Route>
    </Router>
  </Layout>
{:else}
  <Loader />
{/if}
